import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How does the $1 per minute pricing work?",
    a: "You only pay for the time we actually spend on your problem — start to finish. A 12-minute Wi-Fi fix costs $12. A two-hour computer rebuild costs $120. No call-out fee, no minimums, no hidden costs.",
  },
  {
    q: "Who qualifies as an 'eligible senior' for free service?",
    a: "If you're a pensioner or self-funded retiree in our service area, the service is completely free — my way of giving back to the community. Just let me know when you call.",
  },
  {
    q: "Do you come to my home?",
    a: "Yes. Most jobs are done on-site at your home or office across Perth's north-western suburbs. It's easier for you and means I can fix things in the environment where they happen.",
  },
  {
    q: "What if you can't fix the problem?",
    a: "If I can't fix it, you don't pay. I'll tell you honestly what the issue is and recommend the best next step — whether that's a manufacturer warranty claim or a specialist.",
  },
  {
    q: "How quickly can you come out?",
    a: "Most enquiries are booked within the same week, and urgent issues are often handled same-day. The fastest way to find out is to give me a call on 0409 049 094.",
  },
  {
    q: "Do you help with phones and tablets too?",
    a: "Absolutely — iPhones, iPads, Android phones and tablets. Email setup, photo backups, app trouble, account recovery — all welcome.",
  },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="py-20 sm:py-24 bg-white border-y border-slate-200">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
        <p className="text-sm uppercase tracking-[0.18em] font-semibold text-[#D97706]">
          Frequently asked
        </p>
        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          Good questions, honest answers.
        </h2>

        <div className="mt-10">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="border-b border-slate-200"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-lg sm:text-xl font-semibold text-slate-900 hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-slate-700 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
